import React from 'react';

export default function Hero({ lang }) {
  const t = {
    line1: lang === 'de' ? 'BALANCE' : 'BALANCE',
    line2: lang === 'de' ? 'ENERGIE' : 'ENERGY',
    line3: lang === 'de' ? 'WOHLBEFINDEN' : 'WELLBEING',
    tagline: lang === 'de' ? 'DEIN KÖRPER. DEIN GEIST. DEINE GESUNDHEIT.' : 'YOUR BODY. YOUR MIND. YOUR HEALTH.',
    sub:
      lang === 'de'
        ? 'FitXcelerate verbindet funktionelles Training, Achtsamkeit und Ernährungswissenschaft — nachhaltig entwickelt für echtes Wohlbefinden.'
        : 'FitXcelerate combines functional training, mindfulness and nutrition science — sustainably engineered for real wellbeing.',
    cta: lang === 'de' ? 'WOHLBEFINDEN STARTEN' : 'START YOUR WELLNESS',
  };

  return (
    <section className="pt-16 min-h-screen flex items-center bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center py-16 lg:py-24">
          {/* Left — text */}
          <div className="flex flex-col gap-6">
            {/* Stacked headline */}
            <div className="flex flex-col gap-1">
              {[t.line1, t.line2, t.line3].map((word) => (
                <span
                  key={word}
                  className="text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-black tracking-tight leading-none bg-gradient-to-r from-emerald-600 to-lime-500 bg-clip-text text-transparent"
                >
                  {word}
                </span>
              ))}
            </div>

            {/* Tagline */}
            <p className="text-xl sm:text-2xl font-bold text-slate-800 tracking-wide uppercase">
              {t.tagline}
            </p>

            {/* Sub-copy */}
            <p className="text-lg text-slate-500 max-w-md leading-relaxed">
              {t.sub}
            </p>

            {/* CTA */}
            <div className="pt-2">
              <a
                href="/s"
                className="inline-flex items-center gap-2 px-8 py-4 bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-lg rounded-xl shadow-lg hover:shadow-emerald-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5"
              >
                {t.cta}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2.5}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </a>
            </div>

            {/* Social proof strip */}
            <div className="flex items-center gap-4 pt-2">
              <div className="flex -space-x-2">
                {['#059669', '#10b981', '#34d399', '#6ee7b7'].map((c, i) => (
                  <div
                    key={i}
                    className="w-8 h-8 rounded-full border-2 border-white flex items-center justify-center text-white text-xs font-bold"
                    style={{ backgroundColor: c }}
                  >
                    {['A', 'M', 'T', 'S'][i]}
                  </div>
                ))}
              </div>
              <p className="text-sm text-slate-500">
                <span className="font-semibold text-slate-800">1,200+</span>{' '}
                {lang === 'de' ? 'zufriedene Nutzer in der Schweiz' : 'happy users in Switzerland'}
              </p>
            </div>
          </div>

          {/* Right — image */}
          <div className="relative flex justify-center lg:justify-end">
            {/* Decorative blob */}
            <div className="absolute inset-0 -z-10 flex items-center justify-center">
              <div className="w-[420px] h-[420px] rounded-full bg-gradient-to-br from-emerald-100 to-lime-100 blur-3xl opacity-60" />
            </div>

            <div className="relative w-full max-w-lg">
              {/* Green accent ring */}
              <div className="absolute -inset-2 rounded-3xl bg-gradient-to-br from-emerald-400/30 to-lime-400/20 blur-sm -z-10" />
              <img
                src="https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=1600&q=80"
                alt="Fitness workout"
                className="w-full h-[480px] lg:h-[560px] object-cover rounded-3xl shadow-2xl"
              />
              {/* Badge overlay */}
              <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-sm rounded-2xl px-5 py-3 shadow-xl flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-emerald-600 flex items-center justify-center text-white text-lg">
                  💪
                </div>
                <div>
                  <p className="text-xs text-slate-400 font-medium uppercase tracking-wide">
                    {lang === 'de' ? 'Deine Balance' : 'Your Balance'}
                  </p>
                  <p className="text-sm font-bold text-slate-800">
                    {lang === 'de' ? 'Heute fühlen' : 'Feel Today'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
